export const normalizeUrl = (str) => {
  return !(str.startsWith('http://') || str.startsWith('https://'))
    ? `https://${str}`
    : str;
};

export const isUrl = (str) => {
  const expression =
    /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);
  return str.match(regex);
};

export const containsUrl = (str) => {
  return new RegExp(
    '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?',
  ).test(str);
};

export const linkify = (text) => {
  // matches urls that start with http, https, and are part of a set of common domain name endings
  const regex =
    /(?:https?:\/\/.|www.)[-A-Z0-9@:%.+~#=]+\.(?:com|net|org|us|co|gov|biz|info|mil|us)\b(?:[-A-Z0-9@:%_+()~#?&/=]*)/gi;
  // split the quote notes into segments of text that are either links or not links
  // use a positive lookahead for segmentation to keep the delimiters (urls that match the regex)
  const segments = text.split(
    /((?:https?:\/\/.|www.)[-A-Z0-9@:%._+~#=]+\.(?:com|net|org|us|co|gov|biz|info|mil|us)\b(?:[-A-Z0-9@:%_+()~#?&/=]*))/gi,
  );
  // turn the segments into html elements
  return segments.map((segment, index) => {
    const keyValue = `${segment}_${index}`;
    if (segment.match(regex)) {
      let link = segment;
      if (!segment.match('http')) {
        link = 'http://' + segment;
      }
      return (
        // eslint-disable-next-line react/no-array-index-key
        <a href={link} key={keyValue} target="_blank" rel="noopener noreferrer">
          {segment}
        </a>
      );
    } else {
      // eslint-disable-next-line react/no-array-index-key
      return <span key={keyValue}>{segment}</span>;
    }
  });
};
